import { useTranslation } from "react-i18next";

const REVIEWS = [
  {
    name: "Aytən Hüseynova",
    role: "Mühasib, Bakı",
    text: "Mail.net.az-ı istifadə etməyə başlayandan bu yana korporativ yazışmalarım tamamilə təhlükəsizdir. FİN əsaslı giriş sistemi çox etibarlıdır.",
    avatar: "https://readdy.ai/api/search-image?query=professional%20Azerbaijani%20woman%20portrait%2C%20office%20worker%20accountant%2C%20warm%20smile%2C%20business%20attire%2C%20clean%20white%20background%2C%20studio%20photo%2C%20soft%20lighting%2C%20natural%20look&width=80&height=80&seq=rev001&orientation=squarish",
  },
  {
    name: "Rauf Əliyev",
    role: "Müəllim, Gəncə",
    text: "Azərbaycanca interfeys çox rahatdır. Digər email xidmətlərindən fərqli olaraq, burada həm dilimiz, həm də məxfiliyimiz qorunur.",
    avatar: "https://readdy.ai/api/search-image?query=professional%20Azerbaijani%20man%20portrait%2C%20teacher%20school%20educator%2C%20friendly%20smile%2C%20smart%20casual%20clothes%2C%20clean%20background%2C%20studio%20photo%2C%20natural%20lighting&width=80&height=80&seq=rev002&orientation=squarish",
  },
  {
    name: "Leyla Məmmədova",
    role: "Həkim, Sumqayıt",
    text: "Tibbi yazışmalar üçün şifrələnmiş email xidməti vacibdir. Mail.net.az bu sahədə ən etibarlı platforma olmağa davam edir.",
    avatar: "https://readdy.ai/api/search-image?query=professional%20Azerbaijani%20woman%20doctor%20portrait%2C%20friendly%20confident%20smile%2C%20white%20coat%20uniform%2C%20clean%20hospital%20background%2C%20studio%20lighting%2C%20sharp%20focus&width=80&height=80&seq=rev003&orientation=squarish",
  },
  {
    name: "Elnur Quliyev",
    role: "Sahibkar, Bakı",
    text: "Biznes email idarəetməsi çox asandır. 24/7 texniki dəstək xidməti həmişə öz işini görür. Tövsiyə edirəm!",
    avatar: "https://readdy.ai/api/search-image?query=professional%20Azerbaijani%20businessman%20portrait%2C%20confident%20smile%2C%20modern%20suit%2C%20clean%20minimal%20background%2C%20corporate%20headshot%2C%20sharp%20studio%20lighting&width=80&height=80&seq=rev004&orientation=squarish",
  },
  {
    name: "Narmin Əsgərova",
    role: "Hüquqşünas, Lənkəran",
    text: "Hüquqi sənədləşmə üçün Email şifrələməsi mütləq lazımdır. Mail.net.az bu tələbi tam qarşılayır. Xidmət keyfiyyəti əladır.",
    avatar: "https://readdy.ai/api/search-image?query=professional%20Azerbaijani%20woman%20lawyer%20portrait%2C%20confident%20expression%2C%20formal%20business%20attire%2C%20clean%20neutral%20background%2C%20sharp%20studio%20portrait&width=80&height=80&seq=rev005&orientation=squarish",
  },
];

export default function ReviewsSection() {
  const { t } = useTranslation();

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-flex items-center gap-1.5 text-red-600 text-xs font-bold tracking-widest uppercase">
            <i className="ri-star-line" />
            {t("home.reviews_label")}
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mt-2">{t("home.reviews_title")}</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {REVIEWS.slice(0, 3).map((r, i) => (
            <div key={i} className="bg-stone-50 rounded-2xl p-6 flex flex-col gap-4">
              <div className="flex items-center gap-3">
                <img
                  src={r.avatar}
                  alt={r.name}
                  className="w-11 h-11 rounded-full object-cover object-top flex-shrink-0"
                />
                <div>
                  <div className="font-semibold text-gray-900 text-sm">{r.name}</div>
                  <div className="text-xs text-gray-400">{r.role}</div>
                </div>
              </div>
              <div className="text-red-300 text-2xl leading-none">&ldquo;</div>
              <p className="text-sm text-gray-600 leading-relaxed -mt-3">{r.text}</p>
              <div className="flex gap-0.5 mt-auto">
                {[...Array(5)].map((_, k) => (
                  <i key={k} className="ri-star-fill text-amber-400 text-sm" />
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Second row - 2 cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-5">
          {REVIEWS.slice(3, 5).map((r, i) => (
            <div key={i} className="bg-stone-50 rounded-2xl p-6 flex flex-col md:flex-row gap-5">
              <img
                src={r.avatar}
                alt={r.name}
                className="w-14 h-14 rounded-xl object-cover object-top flex-shrink-0"
              />
              <div className="flex flex-col gap-2">
                <div>
                  <div className="font-semibold text-gray-900 text-sm">{r.name}</div>
                  <div className="text-xs text-gray-400">{r.role}</div>
                </div>
                <p className="text-sm text-gray-600 leading-relaxed">{r.text}</p>
                <div className="flex gap-0.5">
                  {[...Array(5)].map((_, k) => (
                    <i key={k} className="ri-star-fill text-amber-400 text-sm" />
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
